// extracted by mini-css-extract-plugin
export default {"backdrop":"style_backdrop__+DGeN","modal":"style_modal__IhSYu","content":"style_content__M1Ml5","close":"style_close__UZ4Ih","confirm":"style_confirm__wink1"};